$(function () {

    $('#home-slider').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 5000,
		speed: 1000,
		dots: true,
		arrows: false,
	});

	// AJAX загрузка событий
    $('#more-events').on('click', function () {
        let _this = $(this);
        var defText = _this.html(); //сохранение текста по умолчанию
        _this.html(loading + '&nbsp;&nbsp;<span class="spinner-border spinner-border-sm" aria-hidden="true"></span>'); // изменение кнопки

        let data = {
            'action': 'loadmore',
            'query': _this.attr('data-param-posts'),
            'page': this_page,
        }

        $.ajax({
            url: '/wp-admin/admin-ajax.php',
            data: data,
            type: 'POST',
            success: function (data) {
                if (data) {
                    _this.html(defText); //возврат текста по умолчанию
                    $('#events-list').append(data); // где вставить данные
                    this_page++;                      // увелич. номер страницы +1
                    if (this_page == _this.attr('data-max-pages')) {
                        _this.remove();               // удаляем кнопку, если последняя стр.
                    }
                } else {                              // если закончились посты
                    _this.remove();                   // удаляем кнопку
                }
            }
        });
    });

	// AJAX загрузка альбомов
    $('#more-albums').on('click', function () {

        $(".pagination").hide(1000);

        let _this = $(this);
        var defText = _this.html(); //сохранение текста по умолчанию
        _this.html(loading + '&nbsp;&nbsp;<span class="spinner-border spinner-border-sm" aria-hidden="true"></span>'); // изменение кнопки

        let data = {
            'action': 'loadmore',
            'query': _this.attr('data-param-posts'),
            'page': this_page,
        }

        $.ajax({
            url: '/wp-admin/admin-ajax.php',
            data: data,
            type: 'POST',
            success: function (data) {
                if (data) {
                    _this.html(defText); //возврат текста по умолчанию
                    $('.albums').append(data); // где вставить данные
                    this_page++;                      // увелич. номер страницы +1
                    if (this_page == _this.attr('data-max-pages')) {
                        _this.remove();               // удаляем кнопку, если последняя стр.
                    }
                } else {                              // если закончились посты
                    _this.remove();                   // удаляем кнопку
                }
            }
        });
    });
	
    // AJAX загрузка постов
    $('#more-news').on('click', function () {
        $(".pagination").hide(1000);
        
        let _this = $(this);
        var defText = _this.html(); //сохранение текста по умолчанию
        _this.html(loading + '&nbsp;&nbsp;<span class="spinner-border spinner-border-sm" aria-hidden="true"></span>'); // изменение кнопки

        let data = {
            'action': 'loadmore',
            'query': _this.attr('data-param-posts'),
            'page': this_page,
        }

        $.ajax({
            url: '/wp-admin/admin-ajax.php',
            data: data,
            type: 'POST',
            success: function (data) {
                if (data) {
                    _this.html(defText); //возврат текста по умолчанию
                    $('.news-list').append(data); // где вставить данные
                    this_page++;                      // увелич. номер страницы +1
                    if (this_page == _this.attr('data-max-pages')) {
                        _this.remove();               // удаляем кнопку, если последняя стр.
                    }
                } else {                              // если закончились посты
                    _this.remove();                   // удаляем кнопку
                }
            }
        });
    });

});